import { RenderSelectInput, RenderTextInput } from "app/common/renderInput";
import { addUpdateSupplierCommission } from "app/services/vendorService";
import { ErrorMessage, Field, Formik } from "formik";
import moment from "moment";
import { useState } from "react";
import {
  Form as BootstrapForm,
  Button,
  Col,
  Modal,
  Row,
  Table,
} from "react-bootstrap";
import { NotificationManager } from "react-notifications";
import * as Yup from "yup";
import CarrierSingleSearch from "./AutoComplete/CarrierSingleSearch";
import UserGroupSearch from "./AutoComplete/UserGroupSearch";
import VendorAndCarrierSearch from "./AutoComplete/VendorAndCarrierSearch";
export default function AddUpdateCommission({
  initialValues,
  setInitialValues,
  show,
  handleClose,
  edit,
  loadCommission,
  setEdit,
  row,
}) {
  const [userGroup, setUserGroup] = useState(null);
  const [selectedCarriers, setSelectedCarriers] = useState([]);
  const [selectedVendor, setSelectedVendor] = useState(null);
  const [isLoading, setIsLoading] = useState(false);
  const validationSchema = Yup.object().shape({
    supplierId: Yup.number().min(1, "Supplier Name is required"),
    carrierId: Yup.number().min(1, "Airlines Name is required"),
    groupId: Yup.number().min(1, "User group is required"),

    // fareNameType: Yup.string().required("Required"),
    fareName: Yup.string().required("Fare Name is required"),
    fare: Yup.object({
      commissionValue: Yup.number()
        .min(0, "Must be 0 or more")
        .required("Required"),
      markupValue: Yup.number()
        .min(0, "Must be 0 or more")
        .required("Required"),
    }),
    food: Yup.object({
      commissionValue: Yup.number()
        .min(0, "Must be 0 or more")
        .required("Required"),
      markupValue: Yup.number()
        .min(0, "Must be 0 or more")
        .required("Required"),
    }),
    seat: Yup.object({
      commissionValue: Yup.number()
        .min(0, "Must be 0 or more")
        .required("Required"),
      markupValue: Yup.number()
        .min(0, "Must be 0 or more")
        .required("Required"),
    }),
    baggage: Yup.object({
      commissionValue: Yup.number()
        .min(0, "Must be 0 or more")
        .required("Required"),
      markupValue: Yup.number()
        .min(0, "Must be 0 or more")
        .required("Required"),
    }),
  });

  const DropdownField = ({ name, options }) => (
    <Field as="select" name={name} className="form-select">
      {/* {["percentage", "static"]} */}
      <option value={"percentage"}>Percentage</option>
      <option value={"static"}>Static</option>
    </Field>
  );
  const closeHandler = () => {
    handleClose();
    loadCommission();
    setInitialValues({
      id: 0,
      supplierId: 0,
      carrierId: 0,
      groupId: 0,
      fullRowStatus: true,
      fareName: "",
      fare: {
        commissionType: "percentage",
        commissionValue: 0,
        markupType: "percentage",
        markupValue: 0,
        typeStatus: true,
      },
      food: {
        commissionType: "percentage",
        commissionValue: 0,
        markupType: "percentage",
        markupValue: 0,
        typeStatus: true,
      },
      seat: {
        commissionType: "percentage",
        commissionValue: 0,
        markupType: "percentage",
        markupValue: 0,
        typeStatus: true,
      },
      baggage: {
        commissionType: "percentage",
        commissionValue: 0,
        markupType: "percentage",
        markupValue: 0,
        typeStatus: true,
      },
    });
    setSelectedVendor(null);
    setSelectedCarriers([]);
    setUserGroup(null);
    setEdit(false);
  };
  const handleSubmit = async (values, { resetForm }) => {
    setIsLoading(true);
    const request = {
      id: values.id,
      supplierId: values.supplierId,
      carrierId: values.carrierId,
      groupId: values.groupId,
      fareNameType: values.fareName,
      fareName: values.fareName,

      fareCommissionType: values.fare.commissionType,
      fareCommissionValue: values.fare.commissionValue,
      fareMarkupType: values.fare.markupType,
      fareMarkupValue: values.fare.markupValue,
      fareTypeStatus: values.fare.typeStatus,
      ///
      foodCommissionType: values.food.commissionType,
      foodCommissionValue: values.food.commissionValue,
      foodMarkupType: values.food.markupType,
      foodMarkupValue: values.food.markupValue,
      foodTypeStatus: values.food.typeStatus,
      /////
      seatCommissionType: values.seat.commissionType,
      seatCommissionValue: values.seat.commissionValue,
      seatMarkupType: values.seat.markupType,
      seatMarkupValue: values.seat.markupValue,
      seatTypeStatus: values.seat.typeStatus,
      /////
      baggageCommissionType: values.baggage.commissionType,
      baggageCommissionValue: values.baggage.commissionValue,
      baggageMarkupType: values.baggage.markupType,
      baggageMarkupValue: values.baggage.markupValue,
      baggageTypeStatus: values.baggage.typeStatus,
      entryDate: `${moment().format("YYYY-MM-DD")}T${moment().format(
        "HH:mm:ss"
      )}Z`,
      modifiedDate: `${moment().format("YYYY-MM-DD")}T${moment().format(
        "HH:mm:ss"
      )}Z`,
      // entryDate: "2025-02-18T04:44:39.276Z",
      // modifiedDate: "2025-02-18T04:44:39.276Z",
      modifyBy: 0,
      createBy: 0,
      fullRowStatus: values.fullRowStatus,
    };
    try {
      const response = await addUpdateSupplierCommission(request);
      if (response.status == "Success") {
        NotificationManager.success(response.message);
      } else {
        NotificationManager.error(response.message);
      }
    } catch (error) {
      NotificationManager.error("Error while saving data");
    }
    setIsLoading(false);
    resetForm(); // Reset form after successful submission
    closeHandler();
  };
  const StatusList = [
    { value: true, label: "Active" },
    { value: false, label: "Inactive" },
  ];
  return (
    <div>
      <Formik
        initialValues={initialValues}
        validationSchema={validationSchema}
        onSubmit={handleSubmit}
        enableReinitialize
      >
        {({
          handleSubmit,
          values,
          setFieldValue,
          touched,
          errors,
          handleChange,
          handleBlur,
        }) => (
          <Modal
            show={show}
            onHide={handleClose}
            backdrop="static"
            keyboard={false}
            size="xl"
          >
            <Modal.Header>
              <Modal.Title>
                {values?.id > 0 ? "Update" : "Add"} Commission
              </Modal.Title>
            </Modal.Header>
            <Modal.Body>
              <BootstrapForm onSubmit={handleSubmit}>
                <Row>
                  <Col>
                    <BootstrapForm.Label>User Group</BootstrapForm.Label>
                    <UserGroupSearch
                      setSelected={setUserGroup}
                      selected={userGroup}
                      setFieldValue={setFieldValue}
                      touched={touched}
                      errors={errors}
                      name={"groupId"}
                      value={values.groupId}
                    />
                  </Col>
                </Row>

                <Row>
                  <Col>
                    <BootstrapForm.Group className="mb-1">
                      <BootstrapForm.Label>Supplier Name</BootstrapForm.Label>
                      <VendorAndCarrierSearch
                        type="vendor"
                        setSelected={setSelectedVendor}
                        selected={selectedVendor}
                        setFieldValue={setFieldValue}
                        touched={touched}
                        errors={errors}
                        edit={edit}
                        userGroupId={values?.groupId}
                        value={values.supplierId}
                      />
                    </BootstrapForm.Group>
                  </Col>
                  <Col>
                    <BootstrapForm.Group className="mb-1">
                      <BootstrapForm.Label>Airlines Name</BootstrapForm.Label>
                      {!edit ? (
                        <CarrierSingleSearch
                          type="flight"
                          setSelected={setSelectedCarriers}
                          selected={selectedCarriers}
                          setFieldValue={setFieldValue}
                          touched={touched}
                          errors={errors}
                          edit={edit}
                          userGroupId={values.groupId}
                          value={values.carrierId}
                        />
                      ) : (
                        <input
                          readOnly
                          className="form-control"
                          value={row?.flightCarrier?.flightCarrierName}
                        />
                      )}
                    </BootstrapForm.Group>
                  </Col>
                </Row>
                <Row>
                  <Col>
                    <BootstrapForm.Group className="mb-1">
                      <RenderTextInput
                        type="text"
                        name="fareName"
                        display={
                          <span>
                            Fare Name{" "}
                            <span className="text-danger">
                              (Such as PUBLISHED or SME)
                            </span>
                          </span>
                        }
                        placeholder="Fare Name"
                        value={values.fareName}
                        error={errors.fareName}
                        onChange={handleChange}
                        onBlur={handleBlur}
                        touched={touched.fareName}
                        required
                      ></RenderTextInput>
                    </BootstrapForm.Group>
                  </Col>

                  <Col>
                    <RenderSelectInput
                      // type="number"
                      name="fullRowStatus"
                      display="Fare Active/Inactive"
                      value={values.fullRowStatus}
                      error={errors.fullRowStatus}
                      onChange={handleChange}
                      onBlur={handleBlur}
                      touched={touched.fullRowStatus}
                      items={StatusList}
                      // required
                    ></RenderSelectInput>
                  </Col>
                </Row>

                {/* Fare Commission & Markup */}

                <Table bordered responsive>
                  <thead>
                    <tr>
                      <th>Type</th>
                      <th>Commission Type</th>
                      <th>Commission Value</th>
                      <th>Markup Type</th>
                      <th>Markup Value</th>
                      <th>Status</th>
                    </tr>
                  </thead>
                  <tbody>
                    {["fare", "food", "seat", "baggage"].map((type, index) => (
                      <tr key={index}>
                        <td className="text-capitalize">{type}</td>

                        {/* Commission Type Dropdown */}
                        <td>
                          <DropdownField name={`${type}.commissionType`} />
                        </td>

                        {/* Commission Value */}
                        <td>
                          <Field
                            type="number"
                            name={`${type}.commissionValue`}
                            className="form-control"
                          />
                          <ErrorMessage
                            name={`${type}.commissionValue`}
                            component="div"
                            className="text-danger"
                          />
                        </td>

                        {/* Markup Type Dropdown */}
                        <td>
                          <DropdownField name={`${type}.markupType`} />
                        </td>

                        {/* Markup Value */}
                        <td>
                          <Field
                            type="number"
                            name={`${type}.markupValue`}
                            className="form-control"
                          />
                          <ErrorMessage
                            name={`${type}.markupValue`}
                            component="div"
                            className="text-danger"
                          />
                        </td>

                        {/* Status Checkbox */}
                        <td className="text-center">
                          <Field
                            type="checkbox"
                            name={`${type}.typeStatus`}
                            className="form-check-input"
                          />
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </Table>
                <Row>
                  <Col
                    style={{
                      justifyContent: "center",
                      display: "flex",
                    }}
                  >
                    <Button
                      variant="secondary"
                      onClick={closeHandler}
                      className="me-2"
                    >
                      Close
                    </Button>
                    {/* Submit Button */}
                    {isLoading ? (
                      <Button variant="primary" disabled>
                        Please wait...
                      </Button>
                    ) : (
                      <Button variant="primary" type="submit">
                        Save
                      </Button>
                    )}
                  </Col>
                </Row>
              </BootstrapForm>
            </Modal.Body>
          </Modal>
        )}
      </Formik>
    </div>
  );
}
